import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertYouTubeIdToImg } from 'appSrc/utils';
import { Link } from 'react-router-dom';
import TextTruncate from 'react-text-truncate';
import AspectRatio from 'react-aspect-ratio';
import { convertToStandard } from 'appSrc/utils/list-article';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/NewPlayIcon';
import { Popup } from 'semantic-ui-react';
import style from './styles/style.module.css';

import defaultListCoverImage from 'appSrc/assets/img/list/default_list_image.png';

const desiresToShowCheck = {
    'mobile': 2,
    'tablet': 2,
    'desktop': 3,
};

class ProductFocusedLACard extends PureComponent {
    constructor(props) {
        super( props );

        this.state = {
            videoPlaying: false,
        };
    }
    renderCoverImage = ( item ) => {
        const youtubeImg = item.video_id && convertYouTubeIdToImg( item.video_id );
        const coverImage = item.cover_image || youtubeImg || defaultListCoverImage;

        return (
            <div className={ style.imageWrapper }>
                <img src={ coverImage } />
            </div>
        );
    }
    render() {
        const item = convertToStandard( this.props.item );
        const author = item.author || {};
        const profession = ( author.profession || {} ).title;
        const desires = item.desires || [];

        const numDesiresToShow = desiresToShowCheck[ this.props.screenType ] || 2;
        const desiresToShow = desires.slice( 0, numDesiresToShow );
        const remainingDesires = desires.length - numDesiresToShow;

        const movieMetaData = {
            attached_to: `${ item.type }_cover_video`,
            attached_id: item.id,
            video_author_id: item.userid,
        };

        return (
            <div className={ `${ style.productFocusedCard } ${ this.props.className }`.trim() }>
                <Link to={ item.internal_link } style={ { zIndex: 2, display: 'block' } }>
                    <AspectRatio ratio='16/9' className={ style.coverWrapper }>
                        { this.renderCoverImage( item ) }
                        <div className={ style.overlayInfo }>
                            <div className={ style.info }>
                                <p className={ style.name }>{ item.title }</p>
                                <p className={ style.userName }>{ author.displayName }</p>
                                <p className={ style.profession }>{ profession }</p>
                            </div>
                            { item.video_id &&
                                <TheaterPlayIcon className={ style.playButton } youtubeId={ item.video_id }
                                metaData={ movieMetaData } />
                            }
                        </div>
                    </AspectRatio>
                </Link>
                <div className={ `${ style.products } semantic-wrapper` }>
                    { desiresToShow.map( ( product ) => {
                        return (
                            <Popup className={ style.productPopup } key={ product.desireid }
                            position='top center'
                            inverted
                            trigger={
                                <Link to={ `/app/products/${ product.desireid }/${ encodeForURI(product.title) }` } className={ style.product }>
                                    <img src={ product.image } alt='product image' />
                                </Link>
                            }>
                                <Popup.Header className={ style.popupHeader }>
                                    <TextTruncate
                                    line={ 2 }
                                    text={ product.title } />
                                </Popup.Header>
                                <Popup.Content className={ style.popupContent }>
                                    <TextTruncate
                                    line={ 2 }
                                    text={ product.description } />
                                    <p className={ style.price }>${ product.price }</p>
                                </Popup.Content>
                            </Popup>
                        );
                    } ) }
                    { remainingDesires > 0 &&
                        <Link to={ item.internal_link } className={ `${ style.product } ${ style.remainder }` }>+{ remainingDesires }</Link>
                    }
                </div>
            </div>
        );
    }
}
ProductFocusedLACard.propTypes = {
    item: PropTypes.object.isRequired,
};
ProductFocusedLACard.defaultProps = {
    className: '',
};

const mapStateToProps = ( state ) => {
    return {
        screenType: state.screenSize.type,
    };
};

export default connect( mapStateToProps )( ProductFocusedLACard );
